<template lang="pug">
.flex.items-center.min-w-0.w-full
  template(v-if="firstTwin")
    TwinField.min-w-0.truncate(
      :twin="firstTwin",
      :show-text-properties="false",
      @click.stop
    )
    el-popover(
      v-if="remainingTwins.length > 0",
      placement="bottom-start",
      trigger="click",
      :width="240"
    )
      template(#reference)
        el-button.ml-2.shrink-0(type="primary", link, @click.stop) {{ $t("andNMore", { n: remainingTwins.length }) }}
      .flex.flex-col.gap-2(@click.stop)
        TwinField(
          v-for="twin in twins",
          :key="twin.uuid",
          :twin="twin",
          :show-text-properties="false"
        )
  span(v-else) -
</template>

<script setup lang="ts">
import { computed } from "vue";
import TwinField from "./TwinField.vue";

type TwinRelation = {
  uuid: string;
  name: string;
  templateId?: string;
};

const props = defineProps<{
  twins: TwinRelation[];
}>();

const firstTwin = computed(() => props.twins[0]);
const remainingTwins = computed(() => props.twins.slice(1));
</script>
